{
  "title": "Reports",
  "subtitle": "Financial and student reports for a fixed period.",
  "exportCsv": "Export CSV",
  "periods": {
    "month": "This month",
    "lastMonth": "Last month",
    "quarter": "This quarter",
    "lastQuarter": "Last quarter",
    "year": "This year",
    "lastYear": "Last year",
    "all": "All time"
  },
  "financial": {
    "heading": "Financial",
    "income": "Income",
    "expenses": "Expenses",
    "net": "Net",
    "outstanding": "Outstanding",
    "indicative": "indicative · at latest rate",
    "incomeByCategory": "Income by category",
    "expenseByCategory": "Expenses by category",
    "netOverTime": "Net profit / loss over time",
    "noIncome": "No income in this period.",
    "noExpenses": "No expenses in this period.",
    "noData": "No financial activity in this period.",
    "month": "Month"
  },
  "outstanding": {
    "heading": "Outstanding payments",
    "student": "Student",
    "fee": "Fee",
    "status": "Status",
    "due": "Due",
    "amount": "Amount",
    "none": "Nothing outstanding.",
    "pending": "Pending",
    "overdue": "Overdue",
    "total": "Total"
  },
  "students": {
    "heading": "Students",
    "countOverTime": "Active students over time",
    "retention": "Retention",
    "byLevel": "By level",
    "byDanceType": "By dance type",
    "byClass": "By class",
    "count": "Students",
    "none": "No data yet.",
    "retention3": "3 months",
    "retention6": "6 months",
    "retention12": "12 months"
  }
}
